<template>
  <router-view />
</template>

<script>
export default {
  name: `App`,
  created () {
    this.$store.dispatch(`fetchMe`);
  },
};
</script>

<style lang="scss">
  body {
    padding: 0px;
    margin: 0px;
    height: 100vh;
    display: block;
    font-family: Roboto;
    overflow-x: hidden;
  }
  input:focus {
    font-weight: 400;
  }
  input {
    color: black !important;
  }
</style>
